<template>
	<b-card no-body>
		<b-card-header class="p-2 d-flex justify-content-between align-items-center">
			<h4 class="mb-0">Collection Details</h4>
			<div class="d-flex align-items-center">
				<el-button type="primary" plain size="small" @click="$refs.doc_discharge_letter.show()" >
					<i class="fa fa-file-pdf"></i> Discharge Letter
				</el-button>
				<el-button type="primary" plain size="small" @click="$refs.drawer_account_statement.show()" >
					View Account Statement
				</el-button>
				<el-button type="primary" plain size="small" @click="openModal()" icon="el-icon-plus" >
					Add Collection
				</el-button>
			</div>
		</b-card-header>
		<!-- <b-row align-h="between" align-v="center" class="p-3">
			<b-col cols="auto">
				<b-form-input v-model="searchQuery" v-on:input="debouncedHandler" placeholder="Search Receipt No, Remar...">
				</b-form-input>
			</b-col>
			<b-col cols="auto" class="d-flex align-items-center">
				<el-date-picker v-model="date_filter" type="date" placeholder="Pick a day" class="mx-2"></el-date-picker>
				<el-select v-model="paid_status" placeholder="Select" class="mx-2">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-button class="float-right px-3 py-2 mb-2 mb-md-0 mx-2" type="gray" plain>
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
						<path fill="currentColor"
							d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z" />
					</svg>
					Filters
				</el-button>
			</b-col>
		</b-row> -->
		<div class="card-table-simple" v-loading="is_loading">
			<b-table-simple responsive class="mb-0">
				<b-thead>
					<b-tr>
						<b-th>Pay Date</b-th>
						<b-th>Receipt No.</b-th>
						<b-th>Instalm. Month</b-th>
						<b-th>Account Group</b-th>
						<b-th>Remarks</b-th>
						<b-th>Paid Status</b-th>
						<b-th>Pay Method</b-th>
						<b-th>Credit (RM)</b-th>
						<b-th>Debit (RM)</b-th>
						<b-th class="text-center">Attachment</b-th>
						<b-th>Status</b-th>
						<b-th></b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<b-tr v-for="(data, index) in tableData" :key="index">
						<b-td>{{ data.pay_date }}</b-td>
						<b-td>{{ data.receipt_no }}</b-td>
						<b-td>{{ data.instalment_month || '-' }}</b-td>
						<b-td>{{ data.account_group }}</b-td>
						<b-td>{{ data.remarks }}</b-td>
						<b-td>{{ data.paid_status }}</b-td>
						<b-td>{{ data.pay_method }}</b-td>
						<b-td>{{ data.credit | moneyFormatter }}</b-td>
						<b-td>{{ data.debit | moneyFormatter }}</b-td>
						<b-td class="text-center">
							<div class="btn btn-icon btn-sm btn-primary rounded-circle cursor-pointer" @click="openModal(data,true)">{{ data.total_attachment }}</div>
						</b-td>
						<b-td>
							<div v-if="!_gHlp.isEmpty(data.apv_id)">
								<div class="d-flex justify-content-start align-items-center" v-if="(_gHlp.checkAccess(['role_credit_head','role_credit_manager','role_admin','role_super_admin']) || (!_gHlp.checkAccess(['collection_approval'])))">
										<el-button type="success" plain size="mini" @click="updateApprovalStatus(data.apv_id,'Approved')" icon="el-icon-check">
											Approve
										</el-button>
										<el-button type="danger" plain size="mini" @click="updateApprovalStatus(data.apv_id,'Rejected')" icon="el-icon-close">
											Reject
										</el-button>
								</div>
								<small v-else>
									<i>Waiting Approval</i>
								</small>
							</div>
							<div v-else>
								<!-- hide update balance before all item approved  -->
								<el-dropdown trigger="click" v-model="data.status" style="cursor: pointer;"
									:disabled="data.status != 'Pending'" @command="updateStatusCollection">
									<p class="el-dropdown-link top-line">
										<span class="d-inline-block text-truncate " :class="_gConst.getColor(data.status)"
											style="max-width: 150px; overflow: unset;">{{ data.status }}</span>
										<i class="el-icon-caret-bottom el-icon--right" v-if="data.status == 'Pending'"></i>
									</p>
									<el-dropdown-menu slot="dropdown">
										<div style="max-height: 300px;overflow-y: auto;">
											<el-dropdown-item v-for="(itm, index) in statusList" :key="index"
												:command="{ lcol_id: data.lcol_id, status: itm }">{{ itm }}</el-dropdown-item>
										</div>
									</el-dropdown-menu>
								</el-dropdown>
								</div>
						</b-td>
						<b-td>
							<el-dropdown trigger="click" style="cursor: pointer">
								<p class="el-dropdown-link mb-0 top-line">
									<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
								</p>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item @click.native="openModal(data)">
										<!-- Eye Icon -->
										<b-icon icon="pencil-square" class="mr-1" variant="gray"></b-icon>
										Edit
									</el-dropdown-item>
									<el-dropdown-item @click.native="remove(data.lcol_id)" v-if="data.paid_status != 'Paid'">
										<span class="text-danger">
											<!-- Trash-Can Icon -->
											<b-icon icon="trash" class="mr-1" variant="gray"></b-icon>
											Delete
										</span>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</b-td>
					</b-tr>
				</b-tbody>
				<b-tfoot>
					<b-tr class="bg-warning">
						<b-td colspan="7">Total</b-td>
						<b-td>{{ totalCredit | moneyFormatter }}</b-td>
						<b-td>{{ totalDebit | moneyFormatter }}</b-td>
						<b-td></b-td>
						<b-td></b-td>
						<b-td></b-td>
					</b-tr>
				</b-tfoot>
			</b-table-simple>
		</div>

		<DrawerAccountStatement ref="drawer_account_statement" />
		<ModalAddCollection ref="modal_add_collection" @closeModal="closeModal($event)" />
		<DocDischargeLetter ref="doc_discharge_letter" />
	</b-card>
</template>
<script>
import { Button, Dropdown, DropdownItem, DropdownMenu, DatePicker, Option, Select } from 'element-ui'
import DrawerAccountStatement from '@/views/CreditLoanCase/Drawers/DrawerAccountStatement'
import ModalAddCollection from '@/views/CreditLoanCase/Modals/ModalAddCollection';
import DocDischargeLetter from '@/views/CreditLoanCase/DocTemplate/DocDischargeLetter';
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { debounce } from '@/assets/js/httpImports.js'
import { cloneDeep } from 'lodash'
import { swal } from '@/assets/js/httpImports.js';
import { mapState, mapActions } from 'pinia';
import { useApprovalStore } from '@/stores/approvalStore';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { useMessagingStore } from '@/stores/messagingStore';
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'

export default {
	mixins: [clientPaginationMixin],
	components: {
		DrawerAccountStatement,
		ModalAddCollection,
		DocDischargeLetter,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[DatePicker.name]: DatePicker,
		[Option.name]: Option,
		[Select.name]: Select,
	},
	data() {
		return {
			is_loading: false,
			editData: {},
			tableData: [],
			debouncedHandler: '',
			date_filter: '',
			options: [{
				value: 'Pending',
				label: 'Pending'
			}, {
				value: 'Paid',
				label: 'Paid'
			}],
			paid_status: ''
		}
	},
	created() {
		this.getListing();
		gEventBus.$on('refresh-collections', this.getListing)
	},
	beforeDestroy() {
		gEventBus.$off('refresh-collections', this.getListing)
	},
	computed: {
		...mapState(useApprovalStore, ['activeApprovalList']),
		...mapState(useLoanCaseStore, ['activeCase']),
		totalDebit() {
			if (_gHlp.isEmpty(this.tableData)) return 0;
			return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.debit), 0);
		},
		totalCredit() {
			if (_gHlp.isEmpty(this.tableData)) return 0;
			return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.credit), 0);
		},
		statusList(){
			return (_gHlp.checkAccess(['role_credit_head','role_credit_manager','role_admin','role_super_admin']) || (!_gHlp.checkAccess(['collection_approval']))) ? ['Pending', 'Submitted','Approved','Rejected'] : ['Pending', 'Submitted'];
		}
	},
	methods: {
		...mapActions(useLoanCaseStore, ['getCase','getCollList', 'updateColl', 'deleteColl']),
		...mapActions(useApprovalStore, ['getAprovalList', 'updateApproval']),
		...mapActions(useNotificationStore, ['createBellNotif']),
		...mapActions(useMessagingStore, ['createSendEmail']),
		openModal(item = null, attachment_only=false) {
			// this.editData = item;
			this.$refs.modal_add_collection.show(cloneDeep(item), attachment_only)
		},
		closeModal(refresh = false) {
			if (refresh) {
				this.getListing();
			}
		},
		getListing() {
			this.is_loading = true;
			this.getCollList({paginate:'no_paginate'}).then(resp => {
				this.tableData = resp.data;
				this.is_loading = false;
			}).catch(err => {
				this.is_loading = false;
			});
		},
		updateStatusCollection(val) {
			let lcol_id = val.lcol_id;
			let status = val.status;

			swal.fire({
				title: 'Status Change',
				text: "Confirm change to " + status,
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.is_loading = true;
					this.updateColl(lcol_id, { status: status }).then(res => {
						if(status == 'Submitted'){
							this.createBellNotif('LMS_CASE_COLLECTION_REQUEST',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name })
							this.createSendEmail('LMS_CASE_COLLECTION_REQUEST',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name })
						}else if(status == 'Approved'){
							this.createBellNotif('LMS_CASE_COLLECTION_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
							this.createSendEmail('LMS_CASE_COLLECTION_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
						}
						_gNotif.notifySuccess("Collection status has been update")
						this.getListing();
						gEventBus.$emit('refresh-cases')
						this.is_loading = false
					});
				}
			})

		},
		remove(id) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					this.deleteColl(id).then(resp => {
						this.getListing();
						gEventBus.$emit('refresh-cases')
						_gNotif.notifySuccess('<b>Collection: </b> - Successfully Deleted.')
					});
				}
			})
		},
		updateApprovalStatus(apv_id,status){
			swal.fire({
				title: 'Approval Confirmation',
				text: "Confirm to " + status + " this request ?",
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.is_loading = true;
					let params = { 
						approve_status: status,
						approve_at: _gHlp.getCurrentDateTime(),
						approve_by: _gAuth.activeUser('id',null)
					}
					this.updateApproval(apv_id, params).then(resp => {
						this.createBellNotif('LMS_CASE_COLLECTION_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
						this.createSendEmail('LMS_CASE_COLLECTION_APPROVAL',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name, action:status })
						this.getCase().then(resp => {
							this.getListing();
							_gNotif.notifySuccess("Approval Request for collection has been "+status);
							this.is_loading = false;
						}).catch(err => {
							this.is_loading = false;
						});
					}).catch(err => {
						this.is_loading = false;
					});
				}
			});
		},
	}
}
</script>